import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ThemeService } from 'src/app/core/services/theme.service';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { DialogService } from '../../services/dialog.service';
import { DialogWidth } from 'src/app/shared/atlas-dialog/enums/dialog-width.enum';
import { LocatorReferenceLibraryDialogComponent } from '../library-management/reference-library-dialog/reference-library-dialog.component';
import * as fromUIStore from 'src/app/core/store';
import { Subscription } from 'rxjs';
import * as fromLocatorStore from 'src/app/locator-store/';
import { LocatorReferenceLibrary } from 'src/app/locator/models/locator-reference-library';
import { ClearStateService } from '../../services/clear-state.service';
import { getHideUsageSection } from '../../store';
import { rebuildHexagonLayerAttempt } from 'src/app/locator-store/actions/locator-shape.actions';
@Component({
  selector: 'atlas-menu',
  templateUrl: './atlas-menu.component.html',
  styleUrls: ['./atlas-menu.component.less'],
  standalone: false
})
export class AtlasMenuComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  private referenceLibraries: LocatorReferenceLibrary[];
  private libraryId: number = 0;
  generateCatchmentH3Data: boolean;
  isCaciUser: boolean = false;

  constructor(
    private themeService: ThemeService,
    private route: Router,
    private authService: AuthService,
    private dialogService: DialogService,
    private locatorStore$: Store<fromLocatorStore.State>,
    private UIStore$: Store<fromUIStore.State>,
    private clearStateService: ClearStateService
  ) {}

  userInfo$ = this.authService.userInfo$;

  hideUsageSection$ = this.locatorStore$.select(getHideUsageSection);

  ngOnInit(): void {
    this.subscription.add(
      this.locatorStore$
        .select(fromLocatorStore.getLocatorReferenceLibraries)
        .subscribe((libraries) => {
          this.referenceLibraries = libraries ? libraries : [];
        })
    );
    this.subscription.add(
      this.locatorStore$
        .select(fromLocatorStore.getLocatorLibraryId)
        .subscribe((libraryId) => {
          this.libraryId = libraryId;
        })
    );
    this.subscription.add(
      this.UIStore$.select(fromUIStore.generateCatchmentH3Data).subscribe(
        (generateCatchmentH3Data) => {
          this.generateCatchmentH3Data = generateCatchmentH3Data;
        }
      )
    );
    this.subscription.add(
      this.authService.userInfo$.subscribe((userInfo) => {
        const email = userInfo?.attributes?.email || '';
        this.isCaciUser = email.toLowerCase().endsWith('@caci.co.uk');
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onToggleTheme() {
    this.themeService.swapTheme();
  }
  onNavigateToStyleGuide() {
    this.route.navigate(['/style-guide']);
  }

  onNavigateToUsage() {
    this.route.navigate(['/reporting/usage']);
    this.clearStateService.resetApplication(false);
  }

  onNavigateToSettings() {
    this.route.navigate(['/reporting/settings']);
    this.clearStateService.resetApplication(false);
  }

  onNavigateToHelp() {
    this.route.navigate(['/reporting/help']);
    this.clearStateService.resetApplication(false);
  }

  onNavigateToReleaseNotes() {
    this.route.navigate(['/reporting/release-notes']);
    this.clearStateService.resetApplication(false);
  }

  onNavigateToAiTools() {
    this.route.navigate(['/reporting/ai-tools']);
    this.clearStateService.resetApplication(false);
  }

  onShowReferenceLibaries() {
    this.dialogService.show(LocatorReferenceLibraryDialogComponent, {
      width: DialogWidth.Small,
      panelClass: 'dialog-full-width-height',
      data: {
        referenceLibraries: this.referenceLibraries
      },
      disableClose: true
    });
  }
  // NOTE: Feature frozen. H3 LAYER FEATURE DISCARDED
  // onUpdateHexagonsLayer() {
  //   this.locatorStore$.dispatch(
  //     rebuildHexagonLayerAttempt({ libraryId: this.libraryId })
  //   );
  // }

  showDarkMode() {
    return environment.baseUrl.includes('localhost');
  }

  showStyleGuide() {
    return environment.baseUrl.includes('localhost');
  }

  showLocatorReferenceLibraries() {
    return this.referenceLibraries.length > 0;
  }

  onLogout() {
    this.authService.logout();
    this.clearStateService.closeAiAssistantOverlay();
  }
}
